module.exports = __webpack_public_path__ + "assets/img/2f22e7f4beca059e852bf235037373fb.svg";